import React, { forwardRef } from "react";
import accessibleGoldenDropdown from "../AccessibleGoldenDropdown";
import OverflowingText from "../../OverflowingText/OverflowingText";
import FilledButton from "../../SelectButton/FilledButton";
import EmptyButton from "../../SelectButton/EmptyButton";

const AccountsDropdown = forwardRef(
  (
    {
      OPTIONS,
      optionRefs,
      isOpen,

      showArrow,
      focusedIndex,
      selected,
      selectedIndex,
      headingValue,
      setHeadingValue,
      position,

      handleOptionKeyDown,
      selectOption,
      restrictHover,
      accessibilityValues,

      popupClassName = {
        open: "",
        close: "",
        wrapperClass: "",
        containerClass: "",
        popupMenuClass: "",
      },
      emailReport = () => {},
      exportAllExcel = () => {},
    },
    // ref,
  ) => {
    return (
      <div
        role={accessibilityValues.ariaHaspopup}
        id={accessibilityValues.ariaControls}
        aria-label={accessibilityValues.ariaLabel}
        className={`popup_menu ${popupClassName.popupMenuClass || ""}  ${
          showArrow === false ? "no_arrow" : ""
        } ${isOpen ? "popup_menu_open" : "popup_menu_close"}`}
        style={{ ...position }}
      >
        <div className="portfolio_report_accounts_container">
          {OPTIONS.map((accountData, index) => {
            const isSelected = selectedIndex === index;
            const isSelectedAccount =
              accountData.account_Code === "All"
                ? headingValue === "All"
                : accountData.account_Code === headingValue?.account_Code;
            const valueToSet =
              accountData.account_Code === "All" ? "All" : accountData;

            return (
              <div
                key={accountData.account_Code}
                ref={(el) => (optionRefs.current[index] = el)}
                role="radio"
                aria-checked={isSelected}
                tabIndex={focusedIndex === index ? 0 : -1}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setHeadingValue(valueToSet);
                  }
                  handleOptionKeyDown(e, index);
                }}
                onClick={() => {
                  setHeadingValue(valueToSet);
                  selectOption(index);
                }}
                className="account_listitem cursor"
              >
                <div className="radio_btn_input">
                  {isSelectedAccount ? <FilledButton /> : <EmptyButton />}
                </div>
                <label
                  className="radio_btn_label cursor"
                  htmlFor={accountData.account_Code}
                >
                  <OverflowingText
                    text={accountData?.account_Name}
                    width={175}
                    textClassName="radio_btn_label cursor_imp"
                    tooltipOnHover={true}
                    position="left"
                    tooltipClassName={
                      index === 0
                        ? "accounts_tooltip_styles_bottom"
                        : "accounts_tooltip_styles"
                    }
                  />
                </label>
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);

export default accessibleGoldenDropdown(AccountsDropdown);
